import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import setSelectedBusinessTravellersAndGuests from 'actions/businessTraveller/setSelectedBusinessTravellerEmployeesAndGuests'
import { saveBusinessTravellerSelectedTravellerState } from 'businessTraveller/storage/businessTravellerStorage'
import { selectBusinessTravellerCurrentApprovalRequest } from 'businessTraveller/selectors/selectBusinessTravellerCurrentApprovalRequest'

/**
 * Initialises the selected traveller from an approved trip request
 * Only used for single selected travellers in a trip request (e.g car hire)
 */
export function useInitialiseTripRequestSingleSelectedTraveller() {
  const dispatch = useAppDispatch()
  const employees = useAppSelector(state => state.businessTraveller.employees?.all)
  const currentApprovalRequest = useAppSelector(selectBusinessTravellerCurrentApprovalRequest)

  useEffect(() => {
    if (!employees || !currentApprovalRequest) return
    // Only initialise for an actionable approval
    if (['DENIED', 'REQUESTED'].includes(currentApprovalRequest.status)) return

    const validEmployeeIds = new Set(Object.keys(employees))
    // Filter to get first employee ID that is in the employees list (i.e. in the business)
    const validSelectedTraveller = currentApprovalRequest.employeeIds?.find(id => validEmployeeIds.has(id)) ?? undefined

    // Set the single selected traveller in state
    dispatch(setSelectedBusinessTravellersAndGuests(validSelectedTraveller ? [validSelectedTraveller] : []))
    // Keep localStorage in sync with redux state
    saveBusinessTravellerSelectedTravellerState(validSelectedTraveller ? [validSelectedTraveller] : [])
  }, [employees, currentApprovalRequest, dispatch])
}
